import { EuiSpacer } from '@elastic/eui';
import RebootTable from 'components/Web_User_Interface/720p_Series/Software/Reboot_Reset/rebootTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  RebootTable,
  BreadCrumbs,
  SEOHelmet,
  React
};